import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Keyboard } from 'lucide-react';

export default function ShortcutsModal({ show, onClose }) {
  const shortcuts = [
    {
      section: 'Global',
      keys: [{ combo: 'Shift + D', action: 'Switch theme' }],
    },
    {
      section: 'Navigation',
      keys: [
        { combo: 'Shift + T', action: 'All Tests' },
        { combo: 'Shift + P', action: 'Pack Analysis' },
        { combo: 'Shift + N', action: 'Notebooks' },
        { combo: 'Shift + M', action: 'My Mistakes' },
        { combo: 'Shift + Enter', action: 'Home' },
      ],
    },
    {
      section: 'Solutions',
      keys: [
        { combo: 'Shift + B', action: 'Toggle bookmarks' },
        { combo: 'Shift + H', action: 'Toggle sidebar' },
        { combo: '→', action: 'Next question' },
        { combo: '←', action: 'Previous question' },
      ],
    },
  ];

  const formatShortcut = (combo) => {
    return combo.split(' + ').map((key, index, array) => (
      <span key={index} className="inline-flex items-center">
        <kbd className="px-2 py-1 text-xs font-medium text-[var(--q3-neutral-default)] bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)] rounded-md shadow-sm">
          {key}
        </kbd>
        {index < array.length - 1 && <span className="mx-2 text-[var(--q3-neutral-default)]">+</span>}
      </span>
    ));
  };

  return (
    <Dialog open={show} onOpenChange={onClose}>
      <DialogContent className="max-w-md p-0 overflow-hidden">
        <div className="p-6 pb-4">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg font-medium text-[var(--q3-neutral-default)]">
              <Keyboard className="w-4 h-4 text-[var(--q3-neutral-default)]" />
              Shortcuts
            </DialogTitle>
          </DialogHeader>
        </div>

        <div className="px-6 pb-6 space-y-6">
          {shortcuts.map((section, i) => (
            <div key={i}>
              <h3 className="mb-3 text-sm font-medium text-[var(--q3-neutral-default)] uppercase tracking-wider">
                {section.section}
              </h3>
              <div className="space-y-2">
                {section.keys.map((shortcut, j) => (
                  <div key={j} className="flex items-center justify-between py-1">
                    <span className="text-sm text-[var(--q3-neutral-light)]">{shortcut.action}</span>
                    <div className="flex items-center">{formatShortcut(shortcut.combo)}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="px-6 py-4 bg-[var(--q3-surface-default)] border-t">
          <p className="text-xs text-[var(--q3-neutral-default)] text-center">
            Press <kbd className="px-1 py-0.5 text-xs bg-[var(--q3-surface-dim)] border rounded">Esc</kbd> to close
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
